import React from "react";
import OptimaSecureCQ from "../Products/OptimaSecure/OptimaSecureCQ";
import useCreateQuotePage from "./useCreateQuotePage";
import Loading from "../Components/Loading";
import { getLocalData } from "../../Utilities/Common/source";
import GoDigitCQ from "./../Products/GoDigit/GoDigitCQ";

const CreateQuotePage = () => {
  const localSource = getLocalData("source");
  console.log("OS CQ localSource: ", localSource);
  const { transferData, acuvisorProductId, transferDataId } =
    useCreateQuotePage();

  //Loading
  if (!transferData) {
    return <Loading />;
  }

  return getProductPage(acuvisorProductId, transferData, transferDataId);
};

const getProductPage = (acuvisorProductId, transferData, transferDataId) => {
  switch (Number(acuvisorProductId)) {
    case 31072023:
      return (
        <OptimaSecureCQ
          transferData={transferData}
          transferDataId={transferDataId}
        />
      );
    case 30102023:
      return (
        <GoDigitCQ
          transferData={transferData}
          transferDataId={transferDataId}
        />
      );
    default:
      return <>No Product Found!</>;
  }
};

export default CreateQuotePage;
